// Renders the toast stack: top right on wide screens, bottom center on phones.
import { useEffect, useState } from "preact/hooks";
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from "lucide-preact";
import { dismiss, flushLater, subscribe, type Toast } from "../lib/toast";
import { t } from "../i18n";

const ICONS = { success: CheckCircle2, warning: AlertTriangle, error: XCircle, info: Info };

export function Toaster() {
  const [items, setItems] = useState<Toast[]>([]);
  useEffect(() => {
    const off = subscribe((list) => setItems([...list]));
    flushLater();
    return off;
  }, []);
  return (
    <div class="toaster" aria-live="polite" aria-atomic="false">
      {items.map((it) => {
        const Icon = ICONS[it.kind];
        return (
          <div key={it.id} class={`toast-item ${it.kind}`} role={it.kind === "error" ? "alert" : "status"}>
            <Icon class="toast-icon" size={20} aria-hidden="true" />
            <span class="toast-text">{it.text}</span>
            <button type="button" class="toast-close" aria-label={t("present.close")} onClick={() => dismiss(it.id)}>
              <X size={16} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
